import { Link } from "react-router-dom";

const linkGroups = [
  {
    title: "影视分类",
    links: [
      { to: "/category/movie", label: "电影" },
      { to: "/category/tv", label: "电视剧" },
      { to: "/category/sci-fi", label: "科幻" },
      { to: "/category/suspense", label: "悬疑" },
      { to: "/category/drama", label: "剧情" },
      { to: "/category/fantasy", label: "奇幻" },
    ],
  },
];

const friendLinks = [
  "影视资讯观察",
  "银幕评论周刊",
  "追剧指南",
  "影迷社区",
  "光影档案",
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-secondary-950 text-secondary-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-extrabold text-background-50">
                  红狐影视
                </span>
                <span className="mt-0.5 text-[11px] tracking-wide text-secondary-400">
                  RED FOX FILM
                </span>
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-300">
              红狐影视专注于提供最新电影和电视剧的资讯、推荐及影评，覆盖丰富影视分类，帮助用户了解热门影视动态，畅享优质影视内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-article-line"].map(
                (icon) => (
                  <span
                    key={icon}
                    className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-900 text-secondary-300 transition-colors hover:bg-primary-500 hover:text-background-50 cursor-pointer"
                  >
                    <i className={`${icon} text-lg`}></i>
                  </span>
                )
              )}
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">
                <span>{group.title}</span>
              </h4>
              <ul className="mt-4 grid grid-cols-2 gap-2.5">
                {group.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-secondary-300 transition-colors hover:text-primary-400"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <span>友情链接</span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {friendLinks.map((f) => (
                <li key={f}>
                  <span className="text-sm text-secondary-300 transition-colors hover:text-primary-400 cursor-pointer">
                    {f}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-secondary-800 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 红狐影视 RED FOX FILM. 保留所有权利。本站内容均为演示用虚构数据。</p>
          <div className="flex flex-wrap gap-4">
            <Link to="/about" className="hover:text-primary-400">
              关于我们
            </Link>
            <span className="cursor-pointer hover:text-primary-400">版权声明</span>
            <span className="cursor-pointer hover:text-primary-400">联系我们</span>
          </div>
        </div>
      </div>
    </footer>
  );
}